import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';
import _get from 'lodash/get';
import moment from 'moment';
import { Reservation } from './reservation.model';
import { EventAdditionalOption } from './event-additional-option.model';

/**
 *@class RoomNumber
 *@property {number} id
 *@property {string} title
 *@property {boolean} editable
 */
export class RoomNumber extends TranslatableModel {

    get CLEAN() {

        return 1;
    }

    get DIRTY() {

        return 0;
    }

    static get DIRTIES() {

        return 0;
    }

    get STATUSES() {

        return {
            [this.CLEAN]: 'CLEAN',
            [this.DIRTY]: 'DIRTY',
        };
    }

    get reservation() {

        return _get(this.attributes, 'accommodation[0].reservation') || false;
    }

    get arrival() {

        return _get(this.attributes, 'accommodation[0].arrival') || false;
    }

    get departure() {

        return _get(this.attributes, 'accommodation[0].departure') || false;
    }

    get occupationStatus() {
        const roomAccommodations = _get(this.attributes, 'accommodation');
        const isAnyOccupied = roomAccommodations.some(accommodation => accommodation.pivot.occupation_status);
        return isAnyOccupied || false;
    }

    get accommodationOccupation() {
        // return the first accommodation occupation status true
        const roomAccommodations = _get(this.attributes, 'accommodation');
        return roomAccommodations.find(accommodation => accommodation.pivot.occupation_status);
    }

    get occupationStatusFormat() {

        return this.occupationStatus ? 'OCCUPIED' : 'VACANT';
    }

    get hasBaseRates() {

        return _get(this.attributes, 'current_accommodation.base_rates').length > 0 || false;
    }

    get roomStatus() {

        const vacant = this.isVacant();

        const roomStyleStatus = {
            blocked: this.blocked === EventAdditionalOption.TYPE_BLOCK_DATES,
            'out-of-service': this.blocked === EventAdditionalOption.TYPE_OUT_OF_SERVICE,
            occupied: !vacant,
            vacant: vacant,
        };

        return Object.entries(roomStyleStatus)
            .find(([_, value]) => value)[0];
    }

    get roomStatusStyles() {

        const roomStatus = this.roomStatus;

        if (roomStatus === 'vacant' && !this.status) {

            return 'vacant-dirty';
        }

        return roomStatus;
    }

    get isDirty() {
        if (this.roomStatus === 'vacant' && !this.status) {
                return true;
        }

        return false;
    }

    get roomStatusWithStars() {

        return this.starStatus.concat(this.roomStatus);
    }

    get starStatus() {

        const confirmedStatuses = [
            Reservation.STATUS_CONFIRMATION_PENDING.key,
            Reservation.STATUS_CONFIRMED.key
        ];

        const stars = [];

        const accommodations = this.attributes.accommodation || [];

        const leastReservationWithoutCheckin = accommodations.some(resAcc => {

            return confirmedStatuses.includes(_get(resAcc, 'reservation.status'))
                && moment().format('YYYY-MM-DD') === resAcc.arrival;
        });

        if (leastReservationWithoutCheckin) {

            stars.push('blue');
        }

        const leastReservationDeparture = accommodations.some(resAcc => {

            const isStatusCheckedOut = [Reservation.STATUS_CHECKED_OUT.key].includes(_get(resAcc, 'reservation.status'));

            return (moment().format('YYYY-MM-DD') === resAcc.departure && !resAcc.same_day_checkout && !isStatusCheckedOut)
                || (moment().add(1, 'day').format('YYYY-MM-DD') === resAcc.departure && resAcc.same_day_checkout && !isStatusCheckedOut);
        });

        if (leastReservationDeparture) {

            stars.push('yellow');
        }

        return stars;
    }

    formatStatus() {

        return this.STATUSES[this.status];
    }

    get stringFormatStatus() {

        return this.STATUSES[this.status];
    }

    isVacant() {

        return !this.occupationStatus;
    }
}

AccessorsMutatorsDecorator(
    'id',
    'abbreviation',
    'status',
    'accommodation',
    'blocked',
    'disturb',
    'comments',
    'housekeeper',
    'housekeeper_id',
    'accommodation_type',
    'property_accommodation_type_id',
    'frontdesk_status',
    'occupation_status',
    'arrival_time',
    'arrival_date',
    'departure_date',
    'shomoos_record_id',
    'shomoos_room_number',
    'floor_no',
    'has_kitchen',
    'has_livingroom',
    'has_master_room',
    'no_of_bedrooms',
    'no_of_beds',
    'sync_update',
    'sync_delete',
)(RoomNumber);



// WEBPACK FOOTER //
// ./src/pms-api/models/room-number.model.js